import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { BASE_PATH } from 'constants/general'
import { useIsMobile } from 'hooks/useIsMobile'
import { decodeStorage, removeStorage } from 'functions/storageBase64'
import PagoTiendaDesktop from './Desktop'
import PagoTiendaMovil from './Movil'

export default function PagarEnTienda() {

    const history = useHistory();
    const { isMobile } = useIsMobile();
    let barCode = `https://csapi.claroshop.com/caja/api/barcodeGen?code=`

    const [payCard, setPayCard] = useState()
    const [idClaro, setIdClaro] = useState()
    const [generar, setGenerar] = useState(false)

    useEffect(() => {
        if (decodeStorage('payCardRelation')) {
            setPayCard(decodeStorage('payCardRelation'))

            setTimeout(function(){
                removeStorage('payCardRelation')
                removeStorage('payCodeSuccess')
            }, 1500) 
        } else {
            history.replace(BASE_PATH)
        }
        setGenerar(false);
    }, [])

    useEffect(() => {
        if (payCard) {
            setIdClaro(payCard?.dataAcount?.card)
        }
    }, [payCard])


    const handleGenerarCodigo = () => {
        setGenerar(true);
    };

    const handleImprimir = () => {
        let printContents = document.getElementById("imprimir").innerHTML;
        let originalContents = document.body.innerHTML;
        window.print();
    };


    return (
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ?
                        <PagoTiendaDesktop 
                            payCard={payCard}
                            barCode={barCode}
                            idClaro={idClaro}
                            generar={generar}
                            handleImprimir={handleImprimir}
                            isMobile={isMobile}
                        />
                    :
                        <PagoTiendaMovil
                            payCard={payCard}
                            barCode={barCode}
                            idClaro={idClaro}
                            handleImprimir={handleImprimir}
                            isMobile={isMobile}
                        />
                : null
            }
        </>
    )
}